import ApiRequests from './ApiRequests'

const Api = new ApiRequests()

export default Api
